require('./dist/angular-shims-placeholder');
module.exports = 'ng.shims.placeholder';



//////////////////
// WEBPACK FOOTER
// ./~/angular-shims-placeholder/index.js
// module id = 447
// module chunks = 36